// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__wpP0Z","tab":"Tabs_tab__5YDdR","tabActive":"Tabs_tabActive__u9KE4"};